import React, { useEffect, useRef } from "react";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import Navbar from "../../components/navbar/navbar";
import "./loginPage.css";
import Footer from "../../components/Footer/Footer";
import { Modal } from "../../components/Modals/ModalComponent/Modal";
import ModalDividerLine from "../../components/Modals/ModalComponent/modal-divider-line";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ErrorPage from "../ErrorPage/error-page";
import { LoaderContext } from "../../context/LoaderContext";
import { OTPInput } from "../../components/OTPInput/otp-input";
import { POST } from "../../utils/httpUtils";
import mfaIcon from "../../assets/images/mfa.png";
import { formatPhoneNumber } from "../../utils/genericUtils";

function MFALogin() {
  const router = useNavigate();
  const { user, loginUser } = useContext(UserContext);
  const { show, showloader, hideloader } = useContext(LoaderContext);

  const error_message = useRef();
  const submit_button = useRef();
  const OTP_INPUT = useRef();
  const remember_device_input = useRef();

  const [params, setParams] = useSearchParams();

  useEffect(() => {
    hideloader();
    if (submit_button.current) submit_button.current.disabled = true;
  }, []);

  if (!user) {
    return (
      <ErrorPage
        header={"Something Went Wrong"}
        errorMessage={"An error occured while passing you to the MFA authentication page, please try again."}
      />
    );
  }

  const to = user.mfaMethod === "email" ? user.email : formatPhoneNumber(user.phone);
  const header = "Mulit-Factor Authenticaton";
  const subtext = (
    <>
      Please Enter The Six Digit Code Sent To: <strong>{to}</strong>
    </>
  );

  function OnChar() {
    if (GetValue().length === 7) {
      submit_button.current.disabled = false;
    } else {
      submit_button.current.disabled = true;
    }
  }

  function ShowErrorMessage() {
    if (error_message.current) {
      return <p className="error-message">*{error_message.current}</p>;
    }
  }

  function GetValue() {
    return OTP_INPUT.current.GetValue();
  }

  async function ResendCode() {
    showloader();
    let response = await POST("/resend-otp", { username: user.username, type: "verify_mfa" });
    hideloader();
  }

  async function Submit() {
    showloader();
    let remember_device = remember_device_input.current.checked;
    let response = await POST("/verify-mfa", { code: GetValue(), id: user.id, remember_device });
    hideloader();
    if (response.success) {
      //check for jwt
      if (response.jwt) {
        if (params.get("remember-me") === true) {
          //save to local storage
          localStorage.setItem("jwt", response.jwt);
        } else {
          sessionStorage.setItem("jwt", response.jwt);
        }
      }

      //set device token if present
      if (response.device_token) {
        localStorage.setItem("device_token", response.device_token);
      }

      //set user
      if (response.user) {
        loginUser(response.user);
      }
      router("/dashboard");
    } else {
      //show validation message
      error_message.current = response.error.message;
    }
  }

  return (
    <>
      <Navbar active="Login"></Navbar>
      <section className="login-page-bg">
        <Modal id={"mfa-login-modal"} showDivider={true} header={header} message={subtext} isActive={true} animate={false} icon={mfaIcon}>
          <OTPInput id={"mfa-verification-otp"} ref={OTP_INPUT} onKey={OnChar} />
          <div className="mfa-verification-controls">
            {ShowErrorMessage()}
            {/* Remember This Device */}
            <div className="remember-me">
              <label htmlFor="">Remember This Device</label>
              <input type="checkbox" ref={remember_device_input} />
            </div>
            <ModalDividerLine showDivider={true} />
            <button ref={submit_button} className="standard-button" onClick={Submit}>
              Submit
            </button>
            <div className="modal-footnote-box">
              <p>didn't recieve a code?</p>
              <button onClick={ResendCode}>resend</button>
            </div>
          </div>
        </Modal>
      </section>
      <Footer />
    </>
  );
}

export default MFALogin;
